import { render, staticRenderFns } from "./studentInfo.vue?vue&type=template&id=427af6e4&scoped=true"
import script from "./studentInfo.vue?vue&type=script&lang=js"
export * from "./studentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427af6e4",
  null
  
)

export default component.exports